import type { ExporterInfo } from '@/entities/monitoring/exporter/@x/docker-tool';

import type { AxiosRequestConfig } from 'axios';
import type { DockerContainer, GetDockerLogs } from '../model/types';
import { dockerToolInstance } from '@/shared/api/api-instances/docker-tool/api-instance';

export class ContainersApi {
  static getContainers(params, options: AxiosRequestConfig = {}) {
    return dockerToolInstance.get<DockerContainer[]>('/containers', {
      ...options,
      params: params,
    });
  }

  static getContainerLogs(
    params: GetDockerLogs,
    options: AxiosRequestConfig = {},
  ) {
    return dockerToolInstance.get<void>('/container/logs', {
      ...options,
      params: params,
    });
  }

  static testContainer(options: AxiosRequestConfig = {}) {
    return dockerToolInstance.get<ExporterInfo[]>('/container/logs/test', {
      ...options,
    });
  }

  static startContainer(
    params: GetDockerLogs,
    options: AxiosRequestConfig = {},
  ) {
    return dockerToolInstance.post<ExporterInfo[]>('/container/start', null, {
      ...options,
      params: params,
    });
  }

  static restartContainer(
    params: GetDockerLogs,
    options: AxiosRequestConfig = {},
  ) {
    return dockerToolInstance.post<ExporterInfo[]>('/container/restart', null, {
      ...options,
      params: params,
    });
  }

  static stopContainer(
    params: GetDockerLogs,
    options: AxiosRequestConfig = {},
  ) {
    return dockerToolInstance.post<ExporterInfo[]>('/container/stop', null, {
      ...options,
      params: params,
    });
  }
}